<button
  class="notification-bell__button"
  type="button"
  aria-label="Notifications"
  (click)="toggle()"
  cdkOverlayOrigin
  #bellTrigger="cdkOverlayOrigin"
>
  <mat-icon>notifications</mat-icon>
  @if (store.hasUnread()) {
    <span class="notification-bell__badge">{{ store.badgeCount() }}</span>
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="bellTrigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="isOpen.set(false)"
>
  <div class="notification-bell__panel">
    <div class="notification-bell__head">
      <span>Notifications</span>
      <div class="notification-bell__actions">
        @if (store.hasUnread()) {
          <button mat-button (click)="markAllRead()">Mark all read</button>
        }
        @if (store.recent().length > 0) {
          <button mat-button (click)="clearAll()">Clear</button>
        }
      </div>
    </div>

    @if (store.loading()) {
      <div class="notification-bell__empty">Loading…</div>
    } @else if (store.recent().length === 0) {
      <div class="notification-bell__empty">Nothing to show.</div>
    } @else {
      <ul class="notification-bell__list">
        @for (item of store.recent(); track item.notificationId) {
          <li
            class="notification-bell__item"
            [class.unread]="!item.readAt"
            [ngClass]="severityClass(item)"
            (click)="open(item)"
          >
            <div class="notification-bell__title">{{ item.title }}</div>
            @if (item.body) {
              <div class="notification-bell__body">{{ item.body }}</div>
            }
            <div class="notification-bell__meta">
              {{ item.severity }} · {{ item.subject }} · {{ item.occurredAt | date: 'short' }}
            </div>
            @if (item.deepLink?.appPath || item.linkUrl) {
              <div class="notification-bell__link">View</div>
            }
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
